<template>
  <div class="container">
    <div style="padding: 1rem;display: flex;">
      <div style="width: 5%;text-align: center;align-items: center;cursor: pointer;"><i class="el-icon-back"
          style="font-size: 3.5rem;" @click="toHome"></i></div>
      <div style="width:95%;">
        <el-steps :active="2" finish-status="success" simple>
          <el-step :title="pageParams.CarTypeName"></el-step>
          <el-step :title="pageParams.SubjectName"></el-step>
          <el-step :title="pageParams.ClassifyName"></el-step>
        </el-steps>
      </div>
    </div>

    <div v-if="showStyle==0">
      <div style="margin: 1.25rem;text-align: center;">
        <div v-for="(item,index) in list" :key="index" class="" style="width: 98%;display: flex;flex-wrap: wrap;">
          <div style="width: 30rem; padding: 0.625rem;border-radius: 0.625rem;margin: 1.25rem 3.125rem 0 0;"
            v-for="(item1,index1) in item.paper" :key="index1"
            :style="{background: item1.color ? item1.color : '#EBF1FF'}">
            <div style="margin: auto;" class="flex">
              <img src="../../assets/images/cateIcon.png" style="width: 5rem;height: 5rem" />
              <div style="font-size: 1.25rem;color: blueviolet;margin-right: 0.625rem;">
                {{index1<9?'0'+(index1+1):index1+1}}
              </div>
              <div
                style="display: flex;justify-content: space-between;align-items: center;width: 100%;cursor: pointer;">
                <div style="width: 12rem;color: #333;font-size: 1.25rem;border: 0.06rem solid #3a8ee6;padding: 0.2rem 1rem;border-radius: 0.2rem;" @click="go(item1,'精选题库')">{{item1.name}}</div>
                <div style="width: 5rem;cursor: pointer;border: 0.06rem solid #3a8ee6;padding: 0.2rem 1rem;border-radius: 0.2rem;" @click="toVideo(item1,'精选题库')">视频讲解</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 分类练习 -->
    <div v-if="showStyle==1">
      <div style="margin: 1.25rem;text-align: center;width: 98%;display: flex;flex-wrap: wrap;">
        <div v-for="(item,index) in list" :key="index" class="">
          <div style="width: 30rem; padding: 0.625rem;border-radius: 0.625rem;margin: 1.25rem 3.125rem 0 0;"
            :style="{background: item.color ? item.color : '#EBF1FF'}">
            <div style="margin: auto;" class="flex">
              <img src="../../assets/images/cateIcon.png" style="width: 5rem;height: 5rem" />
              <div style="font-size: 1.25rem;color: blueviolet;margin-right: 0.625rem;">
                {{index<9?'0'+(index+1):index+1}}
              </div>
              <div
                style="display: flex;justify-content: space-between;align-items: center;width: 100%;cursor: pointer;">
                <div style="width: 12rem;color: #333;font-size: 1.25rem;border: 0.06rem solid #3a8ee6;padding: 0.2rem 1rem;border-radius: 0.2rem;" @click="go(item,'分类练习')">{{item.name}}</div>
                <div style="width: 5rem;cursor: pointer;border: 0.06rem solid #3a8ee6;padding: 0.2rem 1rem;border-radius: 0.2rem;" @click="toVideo(item,'分类练习')">视频讲解</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="middle-section" v-if="pageParams.Action=='三力测试'">
      <div class="vip-box" @click="go(null,'三力测试')">
        <div class="diamond">♦</div>
        <div class="vip-text">真实模拟</div>
        <!-- <div class="vip-desc">尊享特权</div> -->
      </div>
      <div class="vip-box" @click="go(null,'三力测试')">
        <div class="diamond">♦</div>
        <div class="vip-text">模拟考试</div>
        <!-- <div class="vip-desc">尊享特权</div> -->
      </div>
    </div>

    <div style="height: 4rem;min-height: 4rem;"></div>
  </div>
</template>

<script>
  export default {
    name: 'classify',
    data() {
      return {
        showStyle: 0, // 循环遍历的层数
        list: [],
        pageParams: {
          ClassifyName: '',
          CarTypeName: '',
          car_type: '',
          SubjectName: '',
          subject: '',
          Action: ''
        }
      }
    },
    created() {
      // 读取对象（需解析JSON）
      let classify_pageParams = localStorage.getItem('classify_pageParams')
      if (classify_pageParams) {
        classify_pageParams = JSON.parse(classify_pageParams)
        this.pageParams = classify_pageParams
      }
      this.getClassify()
    },
    methods: {
      toHome() {
        window.history.back();
      },
      getClassify() {
        let PageParams_Action = this.pageParams.Action

        let type = ''
        let Array = ['强化题库', '免费题库', '地方题库', '考前密卷', 'VIP题库', '三力测试']
        if (Array.includes(PageParams_Action) == true) {
          type = PageParams_Action
        }

        let vip = 1
        let Array_2 = ['分类练习']
        if (Array_2.includes(PageParams_Action) == true) {
          vip = 0
        }

        if (['分类练习'].includes(PageParams_Action) == true) {
          this.showStyle = 1
        }

        this.axios
          .post('/index/cate', {
            vip: vip,
            subject: this.pageParams.subject,
            car_type: this.pageParams.car_type,
            type: type,
          })
          .then(res => {
            this.list = res
          })
          .catch(error => {})
      },
      go(item, txt) {
        // return
        // if (txt == '分类练习') {
        //   alert('系统不支持此功能')
        //   return
        // }

        localStorage.setItem('CarTypeName', this.pageParams.CarTypeName);

        if (txt == '三力测试') {
          this.$Go('case', {
            id: 1,
            txt: '模拟考试',
            car: this.pageParams.Action,
            carId: this.pageParams.car_type,
            subject: txt,
            subjectId: 7
          })
          return
        }
        this.$Go('case', {
          id: item.id,
          txt: txt,
          car: this.pageParams.Action,
          carId: this.pageParams.car_type,
          subject: item.name,
          subjectId: this.pageParams.subject
        })

      },
      toVideo(item, txt) {
        // console.log(txt)
        // console.log(item)
        // return
        this.$Go('video', {
          id: item.id,
          txt: txt,
          car: this.pageParams.Action,
          carId: this.pageParams.car_type,
          subject: item.name,
          subjectId: this.pageParams.subject
        })
      },
      goSimulate() {
        this.showModal = true
      },
      goVip() {
        console.log('前往VIP页面');
        let car_type_arr = this.vehicleTypes[this.carTypeCheckIndex] // 车型参数数组
        let subject_arr = this.vehicleTypes[this.subjectCheckIndex] // 科目参数数组
        // 存储对象（需先转为JSON字符串）
        const classify_pageParams = {
          ClassifyName: 'VIP题库',
          CarTypeName: car_type_arr['title'],
          car_type: car_type_arr['car_type'],
          SubjectName: subject_arr['text'],
          subject: subject_arr['subject'],
          Action: 'VIP题库'
        };
        localStorage.setItem('classify_pageParams', JSON.stringify(classify_pageParams));
        localStorage.setItem('CarTypeName', classify_pageParams.CarTypeName);
        this.$Go('classify', {})
      }
    }
  }
</script>
<style scoped>
  .container {
    background-color: #4da6ff;
    min-height: 100vh;
    /* 设置最小高度为视口高度 */
    overflow-y: auto;
    /* 当内容超出高度时显示垂直滚动条 */
  }

  .diamond {
    font-size: clamp(2rem, 4vw, 2.5rem);
    /* 使用clamp函数根据视口宽度调整字体大小 */
    line-height: 1;
  }

  .vip-text {
    font-size: clamp(1.25rem, 2vw, 1.5rem);
    /* 使用clamp函数根据视口宽度调整字体大小 */
    font-weight: bold;
    margin-top: clamp(0.125rem, 0.5vw, 0.25rem);
    /* 使用clamp函数根据视口宽度调整边距 */
  }

  .vip-desc {
    font-size: clamp(0.625rem, 1vw, 0.75rem);
    /* 使用clamp函数根据视口宽度调整字体大小 */
    margin-top: clamp(0.0625rem, 0.25vw, 0.125rem);
    /* 使用clamp函数根据视口宽度调整边距 */
  }

  .middle-section {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: clamp(1.5rem, 2vw, 2rem);
    /* 使用clamp函数根据视口宽度调整间距 */
    flex: 0.8;
    margin-top: 5rem;
  }

  .vip-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #ffd700 0%, #ffb347 100%);
    width: clamp(15rem, 20vw, 10rem);
    /* 使用clamp函数根据视口宽度调整尺寸 */
    height: clamp(6rem, 10vw, 8rem);
    /* 使用clamp函数根据视口宽度调整尺寸 */
    border-radius: 3%;
    color: #333;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 8px 30px rgba(255, 215, 0, 0.3);
  }

  .vip-box:hover {
    transform: scale(1.05);
    box-shadow: 0 10px 35px rgba(255, 215, 0, 0.4);
  }
</style>



// WEBPACK FOOTER //
// src/pages/index/classify.vue